import { useEffect } from 'react';

export default () => {
  useEffect(() => {
    // @ts-ignore
    const { controls } = window.Hover.Machete.viewer;
    const { maxPolarAngle: originalMaxPolarAngle } = controls;
    // prevents camera from going below ground (when entering screenshot mode)
    controls.maxPolarAngle = Math.PI / 2;

    return () => {
      // allows camera to go below ground (after exiting screenshot mode)
      controls.maxPolarAngle = originalMaxPolarAngle;
    };
  }, []);
};
